import { Component, ReactNode } from "react";

interface State { error: Error | null; info: string | null; }

/** Top-level boundary: a thrown render error (or a misbehaving browser extension)
 *  shows a readable message + reload instead of a white screen. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null, info: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }
  componentDidCatch(error: Error, info: { componentStack?: string }) {
    this.setState({ info: info?.componentStack || null });
    // eslint-disable-next-line no-console
    console.error("[KontrataPH] render error:", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, fontFamily: "Inter, system-ui, sans-serif", background: "#f5f7fb", color: "#16202e" }}>
        <div style={{ maxWidth: 640, background: "#fff", border: "1px solid #e4e8ef", borderRadius: 12, padding: 24 }}>
          <h1 style={{ margin: "0 0 8px", color: "#0f2540", fontSize: 20 }}>Something went wrong</h1>
          <p style={{ color: "#5b6675", marginTop: 0 }}>
            The page hit an error. If you have browser extensions (e.g. ClickUp, Grammarly), try disabling them for this site or use a private window — they sometimes interfere.
          </p>
          <button
            onClick={() => { try { location.reload(); } catch { /* ignore */ } }}
            style={{ background: "#e0313e", color: "#fff", border: 0, borderRadius: 8, padding: "10px 18px", fontWeight: 700, cursor: "pointer" }}
          >
            Reload
          </button>
          <pre style={{ marginTop: 16, whiteSpace: "pre-wrap", fontSize: 12, color: "#b81f2b", background: "#fdf3f4", padding: 12, borderRadius: 8, overflow: "auto", maxHeight: 320 }}>
            {String(this.state.error?.message || this.state.error)}
            {"\n\n--- stack ---\n"}
            {String(this.state.error?.stack || "(no stack)")}
            {this.state.info ? "\n\n--- component ---" + this.state.info : ""}
          </pre>
        </div>
      </div>
    );
  }
}
